import React from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import { Card, CardBody, Col, Label, Row, TabPane } from "reactstrap";
import AsyncSelect from "react-select/async";
import useActions from "./useActions";
import ModalShowDetail from "./modals/ModalShowDetail";

export default function Diagnoses({
  onChange,
  tabDiagnoses,
  loadDiagnoses,
  patientId,
  isPageModalHistory,
  isActive,
}) {
  const [{ state, columnsHistory }, actions] = useActions({
    patientId,
    isActive,
    appointmentHistoryDiagnoses:
      tabDiagnoses?.appointmentHistoryDiagnoses || [],
    onChange,
    loadDiagnoses,
    isPageModalHistory,
  });

  const { dataHistory, isOpenModalDetail, dataSelected } = state;
  const { toggleModalDetail, getDiagnosisSelectProps, loadingHistoryByPatient } =
    actions;

  const DiagnosisSelect = ({ label, order }) => (
    <Col>
      <Label>{label}</Label>
      <AsyncSelect {...getDiagnosisSelectProps(order)} />
    </Col>
  );

  return (
    <TabPane tabId={5} className="p-0 m-0">
      <ModalShowDetail
        isOpen={isOpenModalDetail}
        toggle={toggleModalDetail}
        dataSelected={dataSelected}
      />
      <Card>
        <CardBody>
          <Row form className="mb-4">
            <DiagnosisSelect label="Diagnostico 1:" order={1} />
            <DiagnosisSelect label="Diagnostico 2:" order={2} />
            <DiagnosisSelect label="Diagnostico 3:" order={3} />
          </Row>

          <Row form>
            <Col>
              <ReactTable
                data={dataHistory || []}
                defaultPageSize={5}
                sortable={false}
                loading={loadingHistoryByPatient}
                noDataText="No hay datos de historia clinica"
                loadingText="Cargando..."
                className="-striped -highlight"
                columns={columnsHistory}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </TabPane>
  );
}
